import { css, SerializedStyles } from '@emotion/core'

import { sizeToProps } from '../constants/sizeToProps'
import { InputSize } from '../types/size'

export const getSizeStyle = (size: InputSize): SerializedStyles => {
  const { spacingX, spacingY } = sizeToProps[size]

  return css`
    padding: ${spacingY} ${spacingX};
  `
}
